import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MetaService } from '@app/core/services/meta.service';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.page.html',
  styleUrls: ['./refund-policy.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NavComponent],
})
export class RefundPolicyPage implements OnInit {
  constructor(private metaService: MetaService) {}

  protected environment = environment;

  protected navItems: NavItem[] = [{ label: 'Refund policy' }];

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro – Refund Policy & Payment Terms',
      description:
        "Read ImageBase.pro's refund policy to understand our terms for payments, cancellations, and eligibility for refunds on stock image purchases.",
      keywords:
        'ImageBase.pro refund policy, payment terms, stock image refunds, cancellation policy, money-back guarantee, purchase terms',
    };

    this.metaService.setMetadata(metadata);
  }
}
